import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { resendVerificationEmail } from '../services/authService';
import styles from '../styles/admin/loginStyles';

const VerificationPending = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Get email from navigation state
        if (location.state?.email) {
            setEmail(location.state.email);
        }
    }, [location]);

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [countdown]);

    const handleResend = async () => {
        if (!email) {
            setMessage('Please enter your email address');
            return;
        }

        setIsLoading(true);
        setMessage('');

        try {
            await resendVerificationEmail(email);
            setMessage('Verification email sent! Please check your inbox.');
            setCountdown(60); // 60 second cooldown
        } catch (error) {
            setMessage(error.message || 'Failed to resend verification email');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={{ ...styles.form, maxWidth: '500px' }}>
                <h2 style={styles.heading}>Verify Your Email</h2>

                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>
                        📧
                    </div>

                    <p style={{ color: '#666', marginBottom: '20px' }}>
                        We've sent a verification email to:
                    </p>

                    {email && (
                        <p style={{ fontWeight: 'bold', color: '#333', marginBottom: '20px' }}>
                            {email}
                        </p>
                    )}

                    <p style={{ color: '#666', marginBottom: '30px' }}>
                        Please check your inbox and click the verification link to activate your account.
                    </p>

                    {!email && (
                        <div style={styles.inputGroup}>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={styles.inputField}
                            />
                        </div>
                    )}

                    {message && (
                        <p style={{
                            ...styles.errorMessage,
                            color: message.includes('sent') ? '#28a745' : '#dc3545',
                            marginBottom: '20px'
                        }}>
                            {message}
                        </p>
                    )}

                    <button
                        style={{
                            ...styles.submitBtn,
                            backgroundColor: countdown > 0 || isLoading ? '#cccccc' : styles.submitBtn.backgroundColor,
                            cursor: countdown > 0 || isLoading ? 'not-allowed' : 'pointer',
                        }}
                        onClick={handleResend}
                        disabled={countdown > 0 || isLoading}
                    >
                        {isLoading ? 'Sending...' : countdown > 0 ? `Resend in ${countdown}s` : 'Resend Verification Email'}
                    </button>

                    <button
                        style={{ ...styles.homeBtn, marginTop: '10px' }}
                        onClick={() => navigate('/login')}
                    >
                        Back to Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerificationPending;
